import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function TransformationVision() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 lg:py-32 bg-brand-dark text-white relative overflow-hidden" data-id="element-360">
      {/* Background image overlay effect */}
      <div className="absolute inset-0 opacity-10 bg-cover bg-center mix-blend-overlay pointer-events-none" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/eMKrXC3836F9SUfpe8Ljc3/heylloyd-image-1780768271075.png")'
    }} data-id="element-361"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-brand-dark via-brand-dark/90 to-brand-dark pointer-events-none" data-id="element-362"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-363">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif font-bold text-brand-gold mb-12" data-id="element-364">
          {t('vision.title')}
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="space-y-8 text-lg md:text-2xl font-serif leading-relaxed text-white/90" data-id="element-365">
          <p className="italic text-white/70" data-id="element-366">{t('vision.p1')}</p>

          <p data-id="element-367">{t('vision.p2')}</p>

          <p data-id="element-368">{t('vision.p3')}</p>

          <p data-id="element-369">{t('vision.p4')}</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="mt-16" data-id="element-370">
          <span className="block text-6xl md:text-8xl lg:text-9xl font-serif font-bold text-brand-gold tracking-widest uppercase drop-shadow-[0_0_30px_rgba(212,164,55,0.4)]" data-id="element-371">
            {t('vision.word')}
          </span>
          <p className="mt-8 text-xl text-white/70 max-w-2xl mx-auto" data-id="element-372">
            {t('vision.desc')}
          </p>
        </motion.div>
      </div>
    </section>;
}